import { useContext, useRef, useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { ItemTypes } from './itemTypes.js'
import { styled } from '@mui/material/styles';

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import styles from './style.module.scss';
import { DrawerContext } from '../../context/drawerContext.js';

export const DragLine = ({ id, text, index, moveCard, ufSigla }) => {
  const ref = useRef(null)
  const {
    setShowMenuOrdering,
    showMenuOrderingEstados,
    setIdEstado
  } = useContext(DrawerContext)

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex)
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex
    },
  })

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#202020',
      color: '#55AAD0',
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  }));
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })
  const style = isDragging ? styles.containerDragLineOpacity : styles.containerDragLineNotOpacity
  drag(drop(ref))
  return (
    <div className={style} ref={ref} data-handler-id={handlerId}>
      {index+1 + ' - ' + text}
      <LightTooltip title="Click aqui para ordenar as câmeras referentes a esta região" placement="top-start">
        <div className={styles.boxLinkCameras}>
          <OpenInNewIcon 
          onClick={() => {
            setShowMenuOrdering(true);
            setIdEstado(ufSigla)
          }}
          />
        </div>
      </LightTooltip>
    </div>
  )
}
